var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bt-container clearfix"},[_c('div',{staticClass:"bt-content clearfix"},[(_vm.step == 1)?_c('wp-step1',{ref:"WpStep1"}):_vm._e(),_vm._v(" "),(_vm.step == 2)?_c('wp-step2',{ref:"WpStep2"}):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"overlay-loader"},[_c('i',{staticClass:"overlay-img-load"})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }